import React from 'react'
import NavBar from '../Components/NavBar'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import PartPrivacyPolicy from '../Components/PrivacyPolicy/PartPrivacyPolicy'

function PandP() {
  return (
    <div>
      <NavBar/>
      <Header/>
      <PartPrivacyPolicy/>
      <Footer/>
    </div>
  )
}

export default PandP